module.exports = __webpack_public_path__ + "static/finelite_hero_bg_old-45dc5d9dbe1224d208ca8f3ab38974da.png";